import type { ListItem } from "../../components/List/List"
import { EEnableStatusType } from "../../Enum/EEnableStatusType"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { faBullhorn, faCalendarDays } from "@fortawesome/free-solid-svg-icons"
import { NoticeEntity } from "../Notice/NoticeEntity"
import { MemoryClass } from "./MemoryClass"

export class NoticeMemory extends MemoryClass<NoticeEntity> {
  setList = (items: NoticeEntity[]) => {
    this.listData = items
  }

  protected cloneEntity(item: NoticeEntity): NoticeEntity {
    return new NoticeEntity({ ...item })
  }

  protected getItemId(item: NoticeEntity): number {
    return item.id
  }

  getListCards = (all: boolean): ListItem[] => {
    let count = 0

    return this.listData
      .filter((e) => all || e.status === EEnableStatusType.Active)
      .map((item) => this.getCard(item, count++))
  }

  getCard(item: NoticeEntity, count: number): ListItem {
    const enabled = item.status === EEnableStatusType.Active
    const hasImage = (item.iconUrl ?? "").trim().length > 0
    const isCurrentlyVisible = item.isVisibleAt(new Date())

    return {
      id: item.id,
      index: count,
      title: item.name,
      isDisable: !enabled,
      linkImage: item.iconUrl,
      dataFilter: [
        item.name,
        item.description,
        isCurrentlyVisible ? "vigente" : "fora do período",
        hasImage ? "com imagem" : "sem imagem",
      ],
      children: (
        <div
          className={`
            rounded-2xl p-4
            transition-all duration-300
            ${enabled ? "bg-gradient-to-r from-orange-50 to-white hover:shadow-lg hover:scale-[1.01]" : "bg-gray-100 opacity-70"}
          `}
        >
          <div className="flex items-start justify-between gap-3">
            <div className="flex gap-3 min-w-0 flex-1">
              <div className="w-12 h-12 rounded-xl bg-amber-200 text-amber-700 flex items-center justify-center shrink-0">
                <FontAwesomeIcon icon={faBullhorn} />
              </div>

              <div className="min-w-0">
                <p className="text-base font-extrabold text-gray-900 truncate">{item.name}</p>
                <p className="text-sm text-gray-700 line-clamp-2 font-medium">{item.description || "Sem descrição"}</p>
              </div>
            </div>

            <span
              className={`px-3 py-1 text-xs font-bold rounded-full whitespace-nowrap ${
                enabled ? "bg-green-100 text-green-700" : "bg-red-100 text-red-600"
              }`}
            >
              {enabled ? "Ativo" : "Inativo"}
            </span>
          </div>

          <div className="border-t border-gray-200 mt-3 pt-3">
            <p className="text-xs text-gray-700 font-semibold flex flex-wrap items-center gap-2">
              <FontAwesomeIcon icon={faCalendarDays} className="text-gray-500" />
              <span>
                {item.startDate.toLocaleDateString()} até {item.endDate.toLocaleDateString()}
              </span>
            </p>

            <div className="flex flex-wrap gap-2 mt-2">
              <span
                className={`px-2 py-1 text-xs rounded-full font-medium ${
                  isCurrentlyVisible ? "bg-green-100 text-green-700" : "bg-amber-100 text-amber-700"
                }`}
              >
                {isCurrentlyVisible ? "Vigente hoje" : "Fora do período"}
              </span>

              {hasImage && <span className="px-2 py-1 text-xs rounded-full bg-cyan-100 text-cyan-700">Com imagem</span>}
            </div>
          </div>
        </div>
      ),
      body: <></>,
    }
  }
}
